var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "plan" },
        [_c("trip-left", { ref: "tripLeft" }), _c("trip-right")],
        1
      ),
      _c("main-right-popup", { ref: "rightPopup" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }